import { render } from "./EditableInput.vue?vue&type=template&id=20bfe6b0&scoped=true&ts=true"
import script from "./EditableInput.vue?vue&type=script&lang=ts"
export * from "./EditableInput.vue?vue&type=script&lang=ts"

import "./EditableInput.vue?vue&type=style&index=0&id=20bfe6b0&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bfe6b0"]])

export default __exports__